import { Box, Stack } from '@mui/material';
import PlaylistAdd from '@mui/icons-material/PlaylistAdd';
import { TbReorder } from 'react-icons/tb';

export const PLAYLIST_PERMISSION_ICON_PX = 20;

const iconBoxSx = (size: number) =>
  ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: size,
    height: size,
    fontSize: size,
    lineHeight: 1,
    flexShrink: 0,
  }) as const;

export function PlaylistPermissionCreateIcon({ size = PLAYLIST_PERMISSION_ICON_PX }: { size?: number }) {
  return <PlaylistAdd sx={iconBoxSx(size)} />;
}

export function PlaylistPermissionReorderIcon({ size = PLAYLIST_PERMISSION_ICON_PX }: { size?: number }) {
  return (
    <Box component="span" sx={iconBoxSx(size)}>
      <TbReorder size={size} />
    </Box>
  );
}

/** Both playlist header permission icons — links flow defaults to per-playlist controls. */
export function PlaylistPermissionPairIcon({ size = PLAYLIST_PERMISSION_ICON_PX }: { size?: number }) {
  return (
    <Stack direction="row" spacing={0.25} alignItems="center" sx={{ flexShrink: 0 }}>
      <PlaylistPermissionCreateIcon size={size} />
      <PlaylistPermissionReorderIcon size={size} />
    </Stack>
  );
}
